import React from 'react';
import { Copy, Icon, Link } from '@honda-canada/design-system-react';
import { Link as RouterLink } from 'react-router-dom';
import themeStyles from './styles/BackButton.styles';
const BackLabel = themeStyles.apply(Copy, 'BackLabel');
const BackLink = themeStyles.apply(Link, 'BackLink');
const BackButton = ({ backStepUrlField }) => {
    if (!backStepUrlField || !backStepUrlField.text || !backStepUrlField.href) {
        return null;
    }
    const { text, href } = backStepUrlField;
    return (React.createElement(BackLink, { as: RouterLink, to: href, "data-testid": "cy-back-cta", disableHover: true },
        React.createElement(Icon, { name: "arrowLeft" }),
        React.createElement(BackLabel, { size: "small" }, text)));
};
export default BackButton;
